// CORE-1735 — Live icon v3 «person» (open profile). Head and shoulders without
// rays (the rays belong to «practice»).
import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Person: React.FC<LiveGlyphProps> = ({ size, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Circle cx={12} cy={8} r={4.2} fill={color} />
    <Path d="M4 20.2c0-4 3.6-6.6 8-6.6s8 2.6 8 6.6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" fill={color} />
  </Svg>
);
